/**
 * @generated SignedSource<<cb7f3bb1b0f9efd91865513cbefa3a8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSignUpStatus = "CONFIRMED" | "DRAFT";
export type ConfirmDraftEventSignUpInput = {
  enrollInLoyalty?: boolean | null | undefined;
  eventSignUpId: string;
  paymentNonce?: string | null | undefined;
};
export type useConfirmDraftEventSignUpMutation$variables = {
  input: ConfirmDraftEventSignUpInput;
};
export type useConfirmDraftEventSignUpMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly eventSignUp: {
      readonly id: string;
      readonly status: EventSignUpStatus;
      readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryContent_signUp">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useConfirmDraftEventSignUpMutation = {
  response: useConfirmDraftEventSignUpMutation$data;
  variables: useConfirmDraftEventSignUpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownRegistrantDisplayName",
  "storageKey": null
},
v12 = [
  (v2/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "payingMember",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhoneNumber",
    "kind": "LinkedField",
    "name": "phoneNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nationalNumber",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConfirmDraftEventSignUpMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "ConfirmDraftEventSignUpPayload",
        "kind": "LinkedField",
        "name": "confirmDraftEventSignUp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventSignUp",
            "kind": "LinkedField",
            "name": "eventSignUp",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "patronLoyalty",
                    "value": false
                  }
                ],
                "kind": "FragmentSpread",
                "name": "EventSignupSummaryContent_signUp"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfirmDraftEventSignUpMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "ConfirmDraftEventSignUpPayload",
        "kind": "LinkedField",
        "name": "confirmDraftEventSignUp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventSignUp",
            "kind": "LinkedField",
            "name": "eventSignUp",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canDelete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waitlistIndex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "EventRegistrationConnection",
                "kind": "LinkedField",
                "name": "registrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationChargeType",
                            "kind": "LinkedField",
                            "name": "primaryChargeType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ChargeRuleSet",
                                "kind": "LinkedField",
                                "name": "chargeRuleSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 1
                                      }
                                    ],
                                    "concreteType": "ChargeRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "chargeRules",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRule",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "price",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "chargeRules(first:1)"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ],
                            "type": "GuestEventRegistration",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Customer",
                                "kind": "LinkedField",
                                "name": "payingCustomer",
                                "plural": false,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CustomerEventRegistration",
                            "abstractKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "registrant",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "profileImage",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "publicId",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "renderingKey",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "Member",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "Customer",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v8/*: any*/),
                            "concreteType": "EventFormResponseConnection",
                            "kind": "LinkedField",
                            "name": "formResponses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventFormResponseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventFormResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "booleanValue",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "stringValue",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FormQuestionConfiguration",
                                        "kind": "LinkedField",
                                        "name": "questionConfiguration",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v10/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "prompt",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TransportationType",
                                        "kind": "LinkedField",
                                        "name": "transportationType",
                                        "plural": false,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "formResponses(first:50)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "index",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/)
                            ],
                            "type": "MemberEventRegistration",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "registrations(first:50)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "active",
                    "value": true
                  }
                ],
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTaxes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "orders(active:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "signUpWindow",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cancelDeadlineAt",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryChargeType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prePaymentRequirement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSeries",
                    "kind": "LinkedField",
                    "name": "eventSeries",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isEventPrePaymentEnabled",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareCardOnFile",
                "kind": "LinkedField",
                "name": "paymentCardOnFile",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkedIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerClient",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": "memberOwnerId",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31aae79b9a7beff3b34084b7eaa89986",
    "id": null,
    "metadata": {},
    "name": "useConfirmDraftEventSignUpMutation",
    "operationKind": "mutation",
    "text": "mutation useConfirmDraftEventSignUpMutation(\n  $input: ConfirmDraftEventSignUpInput!\n) {\n  responsePayload: confirmDraftEventSignUp(input: $input) {\n    eventSignUp {\n      id\n      status\n      ...EventSignupSummaryContent_signUp_9obry\n    }\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    success\n  }\n}\n\nfragment EventSignupSummaryActions_signUp on EventSignUp {\n  id\n  canDelete\n  status\n  waitlistIndex\n  checkedIn\n  signUpWindow {\n    cancelDeadlineAt\n    id\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n      memberOwnerId: id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n        }\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          ... on Member {\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            email\n          }\n          ... on Customer {\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            email\n          }\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryContent_signUp_9obry on EventSignUp {\n  id\n  canDelete\n  status\n  waitlistIndex\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n  signUpWindow {\n    cancelDeadlineAt\n    id\n  }\n  ...EventSignupSummaryPlayerList_signUp\n  ...EventSignupSummaryTotal_signUp\n  ...EventSignupSummaryPaymentSummary_signUp_9obry\n  ...EventSignupSummaryReservation_signUp_9obry\n  ...EventSignupSummaryActions_signUp\n}\n\nfragment EventSignupSummaryPaymentSummary_signUp_9obry on EventSignUp {\n  id\n  status\n  waitlistIndex\n  event {\n    id\n    prePaymentRequirement\n    eventSeries {\n      facility {\n        id\n        isEventPrePaymentEnabled\n      }\n      id\n    }\n    primaryChargeType\n  }\n  paymentCardOnFile {\n    id\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on CustomerEventRegistration {\n          payingCustomer {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n  ...EventSignupSummaryTotal_signUp\n}\n\nfragment EventSignupSummaryPlayerList_signUp on EventSignUp {\n  registrations(first: 50) {\n    edges {\n      node {\n        id\n        __typename\n        type\n        ... on GuestEventRegistration {\n          unknownRegistrantDisplayName\n        }\n        ... on CustomerEventRegistration {\n          unknownRegistrantDisplayName\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            displayName\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              questionConfiguration {\n                id\n                type\n                prompt\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryReservation_signUp_9obry on EventSignUp {\n  id\n  status\n  waitlistIndex\n  event {\n    id\n    prePaymentRequirement\n    eventSeries {\n      facility {\n        id\n        isEventPrePaymentEnabled\n      }\n      id\n    }\n    primaryChargeType\n  }\n  paymentCardOnFile {\n    id\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on CustomerEventRegistration {\n          payingCustomer {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryTotal_signUp on EventSignUp {\n  status\n  event {\n    id\n    primaryChargeType\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            displayName\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7e8682524ef4f203bce989edf691292";

export default node;
